import CustomErrorPage from "@components/Pages/ErrorPage/CustomErrorPage"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"

const notFoundPage = () => {
	return (
		<>
			<HeadMeta
				meta={{
					author: "Dream Broker",
					description: "Not Found",
					keywords: "book a demo",
					ogDescription: "Not Found",
					ogImage: "/DB.jpg",
					ogTitle: "Not Found",
					ogType: "WebPage",
					title: "Not Found | Dreambroker",
				}}
			/>
			<CustomErrorPage statusCode={404} />
		</>
	)
}

export default notFoundPage
